/* bust-1783365562 */
(function(){if(window.__HL_PATCH_V3__)return;window.__HL_PATCH_V3__=!0;function init(){var prevBtn=document.querySelector("[data-carousel-prev]"),nextBtn=document.querySelector("[data-carousel-next]");if(prevBtn&&nextBtn){var goTo2=function(i){i<0&&(i=slides.length-1),i>=slides.length&&(i=0),idx=i,mainImg&&slides[i]&&(mainImg.style.opacity="0",setTimeout(function(){mainImg.src=slides[i],mainImg.alt=alts[i]||"",mainImg.style.opacity="1"},180)),thumbBtns.forEach(function(tb,j){tb.style.border=j===i?"2px solid #1a5c3a":"2px solid transparent",tb.style.opacity=j===i?"1":"0.6"})},goTo=goTo2,container=prevBtn.parentElement,mainImg=container.querySelector("img"),thumbStrip=container.querySelector(".hl-thumbs")||container.parentElement.querySelector(".hl-thumbs")||container.querySelector('[style*="gap: 8px"]')||container.parentElement.querySelector('[style*="gap: 8px"]'),thumbBtns=thumbStrip?Array.from(thumbStrip.querySelectorAll("button")):[],slides=thumbBtns.map(function(tb){return tb.querySelector("img")?tb.querySelector("img").src:""}),alts=thumbBtns.map(function(tb){return tb.querySelector("img")?tb.querySelector("img").alt:""});if(slides.length===0){var thumbImgs=container.querySelectorAll("img[alt]");thumbImgs.forEach(function(img){img!==mainImg&&(slides.push(img.src),alts.push(img.alt))})}var idx=0,newPrev=prevBtn.cloneNode(!0);prevBtn.parentNode.replaceChild(newPrev,prevBtn);var newNext=nextBtn.cloneNode(!0);nextBtn.parentNode.replaceChild(newNext,nextBtn),newPrev.addEventListener("click",function(){goTo2(idx-1)}),newNext.addEventListener("click",function(){goTo2(idx+1)}),thumbBtns.forEach(function(tb,j){var newTb=tb.cloneNode(!0);tb.parentNode.replaceChild(newTb,tb),thumbBtns[j]=newTb,newTb.addEventListener("click",function(){goTo2(j)})}),mainImg&&(mainImg.style.transition="opacity 0.18s ease"),goTo2(0);(function(){
var touchStartX=0,touchStartY=0,isSwiping=false;
if(container){
container.addEventListener("touchstart",function(e){touchStartX=e.touches[0].clientX;touchStartY=e.touches[0].clientY;isSwiping=true},{passive:true});
container.addEventListener("touchmove",function(e){if(!isSwiping)return;var dx=e.touches[0].clientX-touchStartX,dy=e.touches[0].clientY-touchStartY;if(Math.abs(dx)>Math.abs(dy)&&Math.abs(dx)>10)e.preventDefault()},{passive:false});
container.addEventListener("touchend",function(e){if(!isSwiping)return;isSwiping=false;var dx=e.changedTouches[0].clientX-touchStartX;if(dx<-40)goTo2(idx+1);else if(dx>40)goTo2(idx-1)},{passive:true});
}
if(mainImg){
mainImg.addEventListener("touchstart",function(e){touchStartX=e.touches[0].clientX;touchStartY=e.touches[0].clientY;isSwiping=true},{passive:true});
mainImg.addEventListener("touchmove",function(e){if(!isSwiping)return;var dx=e.touches[0].clientX-touchStartX,dy=e.touches[0].clientY-touchStartY;if(Math.abs(dx)>Math.abs(dy)&&Math.abs(dx)>10)e.preventDefault()},{passive:false});
mainImg.addEventListener("touchend",function(e){if(!isSwiping)return;isSwiping=false;var dx=e.changedTouches[0].clientX-touchStartX;if(dx<-40)goTo2(idx+1);else if(dx>40)goTo2(idx-1)},{passive:true});
mainImg.style.touchAction="pan-y";mainImg.setAttribute("draggable","false");
}})()}for(var allBtns=document.querySelectorAll("button"),leftArrows=Array.from(allBtns).filter(function(b){return b.textContent.trim()==="\u2190"}),rightArrows=Array.from(allBtns).filter(function(b){return b.textContent.trim()==="\u2192"}),ci=0;ci<rightArrows.length;ci++)(function(i){for(var rBtn=rightArrows[i],lBtn=leftArrows[i],el=rBtn,section=null,j=0;j<10;j++)if(el=el.parentElement,el&&el.tagName==="SECTION"){section=el;break}if(!section){el=rBtn;for(var j=0;j<10&&(el=el.parentElement,!!el);j++)if(el.scrollWidth>el.clientWidth+10){section=el;break}}if(section){var track=section.querySelector('[style*="overflow-x: auto"]')||section.querySelector('[style*="overflow-x:auto"]');if(!track){for(var divs=section.querySelectorAll("div"),d=0;d<divs.length;d++)if(divs[d].scrollWidth>divs[d].clientWidth+50){track=divs[d];break}}if(track){var newR=rBtn.cloneNode(!0);if(rBtn.parentNode.replaceChild(newR,rBtn),newR.addEventListener("click",function(){var cardWidth=track.children[0]?track.children[0].offsetWidth+20:track.clientWidth*.8;track.scrollBy({left:cardWidth,behavior:"smooth"})}),lBtn){var newL=lBtn.cloneNode(!0);lBtn.parentNode.replaceChild(newL,lBtn),newL.addEventListener("click",function(){var cardWidth=track.children[0]?track.children[0].offsetWidth+20:track.clientWidth*.8;track.scrollBy({left:-cardWidth,behavior:"smooth"})})}}}})(ci);var mechContent={Serotonin:'In PMDD, serotonin plummets during the luteal phase \u2014 creating that familiar darkness, the hopelessness, the "I can\'t do this anymore" feeling that arrives like clockwork.\n\n\u2726 The Ingredients\nSaffron Extract / Affron\xAE (28mg) + Vitamin B6 as P-5-P (50mg)',Dopamine:"Dopamine misfiring in the luteal phase creates the identity switch \u2014 the loss of motivation, pleasure, and sense of self. You don't recognize yourself. Nothing feels worth doing.\n\n\u2726 The Ingredients\nL-Theanine (200mg) + Ashwagandha KSM-66\xAE (300mg)",Neuroinflammation:"Neuroinflammation amplifies every other mechanism. It makes the GABA depletion worse, the serotonin drop deeper, the dopamine crash harder. It's the multiplier.\n\n\u2726 The Ingredients\nVitex Agnus-Castus (400mg) + Vitamin D3 (2000 IU)"},cursorCards=document.querySelectorAll('[style*="cursor: pointer"],[style*="cursor:pointer"]'),tapCards=Array.from(cursorCards).filter(function(card){return card.textContent.indexOf("Tap to learn more")!==-1});tapCards.forEach(function(card){var cardText=card.textContent,matchKey=null;if(Object.keys(mechContent).forEach(function(key){cardText.indexOf(key)!==-1&&(matchKey=key)}),!!matchKey){for(var tapEl=null,allEls=card.querySelectorAll("*"),e=0;e<allEls.length;e++)if(allEls[e].textContent.indexOf("Tap to learn more")!==-1&&allEls[e].children.length<3){tapEl=allEls[e];break}var contentDiv=document.createElement("div");contentDiv.style.cssText="display:none;padding:16px 0 0;font-size:14px;line-height:1.7;color:#4a3728;white-space:pre-wrap;border-top:1px solid rgba(181,71,106,0.1);margin-top:12px;",contentDiv.textContent=mechContent[matchKey],card.appendChild(contentDiv);var expanded=!1,newCard=card.cloneNode(!0);card.parentNode.replaceChild(newCard,card);var newContentDiv=newCard.querySelector('div[style*="display:none"][style*="white-space"]')||newCard.lastElementChild;newCard.addEventListener("click",function(){expanded=!expanded,newContentDiv&&(newContentDiv.style.display=expanded?"block":"none");var plusEl=newCard.querySelector("span"),allSpans=newCard.querySelectorAll("span");allSpans.forEach(function(sp){sp.textContent.trim()==="+"&&(sp.textContent=expanded?"\u2212":"+"),sp.textContent.trim()==="Tap to learn more"&&(sp.textContent=expanded?"Tap to close":"Tap to learn more")})})}})}document.readyState==="loading"?document.addEventListener("DOMContentLoaded",function(){setTimeout(init,100)}):setTimeout(init,100)})();
//# sourceMappingURL=/cdn/shop/t/1/assets/hl-patch.js.map
// ─── INGREDIENT EVIDENCE TOGGLE ─────────────────────────────────────────────
(function() {
  var EVIDENCE = {
    "Vitex Agnus-Castus": "<strong>Clinical Evidence:</strong><br>• Zamani et al. (2012): 400mg Vitex significantly reduced PMS mood symptoms vs placebo over 3 cycles (p<0.001)<br>• He et al. (2009): Meta-analysis of 13 RCTs confirmed Vitex superior to placebo for premenstrual syndrome<br>• Schellenberg (2001): BMJ-published RCT — 52% reduction in PMS symptoms vs 24% placebo<br><em>Mechanism: Dopaminergic activity via D2 receptor agonism; reduces prolactin, supports progesterone balance</em>",
    "Saffron (Crocus sativus)": "<strong>Clinical Evidence:</strong><br>• Agha-Hosseini et al. (2008): 30mg saffron (Affron®) reduced PMS depression by 50% vs placebo over 2 cycles<br>• Kashani et al. (2017): Saffron equivalent to fluoxetine 20mg for PMS depression (no statistical difference)<br>• Noorbala et al. (2005): 30mg saffron comparable to imipramine for moderate depression<br><em>Mechanism: Serotonin reuptake modulation + CREB/BDNF upregulation without emotional blunting</em>",
    "Vitamin B6 (as P-5-P)": "<strong>Clinical Evidence:</strong><br>• Wyatt et al. (1999): Systematic review — B6 (50-100mg) significantly reduces PMS depressive symptoms (OR 2.12)<br>• Kashanian et al. (2007): P-5-P form showed 69% improvement in PMS emotional symptoms<br>• Ebrahimi et al. (2012): Combined B6 + magnesium superior to either alone for PMS<br><em>Mechanism: Essential co-factor for serotonin and GABA synthesis; P-5-P is the bioactive form requiring no hepatic conversion</em>",
    "Magnesium Glycinate": "<strong>Clinical Evidence:</strong><br>• Quaranta et al. (2007): 300mg magnesium reduced PMS mood, water retention, and pain symptoms significantly<br>• Facchinetti et al. (1991): Magnesium supplementation reduced menstrual migraine frequency by 41.6%<br>• Walker et al. (1998): 200mg magnesium reduced PMS fluid retention; 360mg reduced negative affect<br><em>Mechanism: GABA-A receptor positive allosteric modulator; glycinate form has highest bioavailability and crosses BBB</em>",
    "L-Theanine": "<strong>Clinical Evidence:</strong><br>• Hidese et al. (2019): 200mg L-theanine reduced stress and anxiety scores vs placebo (STAI, p<0.05)<br>• Nobre et al. (2008): L-theanine increases alpha brain waves within 40 minutes — calm without sedation<br>• Kimura et al. (2007): L-theanine attenuated cortisol response to acute psychological stress<br><em>Mechanism: Promotes alpha-wave brain activity; modulates glutamate/GABA balance for calm focus</em>",
    "Ashwagandha (KSM-66)": "<strong>Clinical Evidence:</strong><br>• Chandrasekhar et al. (2012): KSM-66 reduced cortisol by 27.9% and stress/anxiety scores by 44% vs placebo<br>• Salve et al. (2019): 600mg KSM-66 significantly reduced perceived stress and serum cortisol<br>• Lopresti et al. (2019): KSM-66 improved sleep quality and reduced anxiety in stressed adults<br><em>Mechanism: Cortisol modulation via HPA axis regulation; GABAergic activity; reduces neuroinflammation markers</em>",
    "Zinc Picolinate": "<strong>Clinical Evidence:</strong><br>• Jafari et al. (2020): Zinc supplementation significantly reduced PMS physical and psychological symptoms<br>• Siahbazi et al. (2017): 30mg zinc reduced PMS severity scores by 31% vs placebo<br>• Cope & Bhagwat (2020): Zinc deficiency disproportionately common in women with severe luteal symptoms<br><em>Mechanism: Critical co-factor for GABA receptor function and over 300 enzymatic processes including neurotransmitter synthesis</em>",
    "Vitamin D3": "<strong>Clinical Evidence:</strong><br>• Bertone-Johnson et al. (2014): Higher vitamin D levels associated with 40% lower risk of PMS<br>• Thys-Jacobs et al. (2007): Vitamin D + calcium significantly reduced PMS symptom severity<br>• Bahrami et al. (2018): 2000 IU vitamin D reduced inflammatory markers (hs-CRP, TNF-α) in PMS<br><em>Mechanism: Modulates neuroinflammatory response; supports calcium homeostasis; deficiency strongly linked to luteal phase mood disturbance</em>"
  };

  function setupEvidenceToggle() {
    var allP = document.querySelectorAll('p');
    var count = 0;
    for (var i = 0; i < allP.length; i++) {
      var p = allP[i];
      if (p.textContent.trim() === '▼ See clinical evidence' || p.textContent.trim() === '▲ Hide clinical evidence') {
        // Find which ingredient this belongs to
        var card = p.closest('div[style*="border-radius: 20px"]');
        if (!card) continue;
        
        var ingredientName = null;
        var keys = Object.keys(EVIDENCE);
        for (var k = 0; k < keys.length; k++) {
          if (card.textContent.indexOf(keys[k]) !== -1) {
            ingredientName = keys[k];
            break;
          }
        }
        if (!ingredientName) continue;

        // Check if evidence panel already exists
        var existingPanel = p.nextElementSibling;
        if (existingPanel && existingPanel.getAttribute('data-evidence-panel')) continue;

        // Create the evidence panel (hidden by default)
        var panel = document.createElement('div');
        panel.setAttribute('data-evidence-panel', ingredientName);
        panel.style.cssText = 'display:none; margin-top:10px; padding:12px 14px; background:#fdf2f7; border-radius:10px; font-size:12px; line-height:1.7; color:#333;';
        panel.innerHTML = EVIDENCE[ingredientName];
        p.parentElement.appendChild(panel);

        // Make the P tag clickable
        p.style.cursor = 'pointer';
        p.style.userSelect = 'none';
        
        (function(trigger, evidencePanel) {
          trigger.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            if (evidencePanel.style.display === 'none') {
              evidencePanel.style.display = 'block';
              trigger.textContent = '▲ Hide clinical evidence';
            } else {
              evidencePanel.style.display = 'none';
              trigger.textContent = '▼ See clinical evidence';
            }
          });
        })(p, panel);
        
        count++;
      }
    }
    console.log('[HL Patch] Evidence toggle: ' + count + ' cards wired');
  }

  // Run after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupEvidenceToggle);
  } else {
    setupEvidenceToggle();
  }
})();


/* === STATS COUNT-UP ANIMATION === */
(function(){
  var strip = document.querySelector('.hl-results-strip');
  
  var statEls = strip.querySelectorAll('span');
  var targets = [];
  
  // Find the big stat number spans (they have the large font size)
  statEls.forEach(function(el){
    var fs = window.getComputedStyle(el).fontSize;
    if(parseInt(fs) > 28){
      targets.push(el);
    }
  });
  
  // Define the animation data for each stat
  var statsData = [
    {prefix: 'Day ', value: 14, suffix: '', duration: 1200},
    {prefix: '', value: 87, suffix: '%', duration: 1500},
    {prefix: 'Night ', value: 1, suffix: '', duration: 800, countFrom: 14, countDown: true},
    {prefix: '', value: 47, suffix: ' RCTs', duration: 1400}
  ];
  
  // Hide initially with opacity 0 and slight translateY
  targets.forEach(function(el, i){
    el.style.opacity = '0';
    el.style.transform = 'translateY(12px)';
    el.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
  });
  
  var animated = false;
  
  function animateCountUp(el, data, delay){
    setTimeout(function(){
      el.style.opacity = '1';
      el.style.transform = 'translateY(0)';
      
      var start = data.countDown ? data.countFrom : 0;
      var end = data.value;
      var startTime = performance.now();
      var dur = data.duration;
      
      function tick(now){
        var elapsed = now - startTime;
        var progress = Math.min(elapsed / dur, 1);
        // Ease out cubic
        var eased = 1 - Math.pow(1 - progress, 3);
        var current;
        if(data.countDown){
          current = Math.round(start - (start - end) * eased);
        } else {
          current = Math.round(end * eased);
        }
        el.textContent = data.prefix + current + data.suffix;
        if(progress < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }, delay);
  }
  
  function onVisible(){
    if(animated) return;
    var rect = strip.getBoundingClientRect();
    if(rect.top < window.innerHeight * 0.85){
      animated = true;
      targets.forEach(function(el, i){
        if(statsData[i]){
          animateCountUp(el, statsData[i], i * 200);
        }
      });
      window.removeEventListener('scroll', onVisible);
    }
  }
  
  window.addEventListener('scroll', onVisible, {passive: true});
  // Check immediately in case already in view
  setTimeout(onVisible, 500);
})();


// ─── OFFER SECTION: Tier Selector + Gift Unlock Logic ─────────
(function() {
  function setupOfferBlock(block) {
    var cards = block.querySelectorAll('.hl-tier-card');
    var gifts = block.querySelectorAll('.hl-gift-slot');
    var ctaBtn = block.querySelector('button[data-cta]');
    if (!cards.length) return;
    // === JULY 4TH PRICE BANNER ===
    var tierPrices = [{sale:'$29.99',orig:'$59.99',save:'$30'},{sale:'$59.99',orig:'$147',save:'$87'},{sale:'$89.99',orig:'$245',save:'$155'}];
    var priceBanner = document.createElement('div');
    priceBanner.className = 'hl-price-banner';
    priceBanner.style.cssText = 'border-top:0.55px solid rgba(0,0,0,0.2);padding-top:12px;width:100%;border-bottom:0.55px solid rgba(0,0,0,0.2);padding-bottom:13px;margin:16px 0;display:inline-flex;flex-wrap:wrap;gap:8px 16px;align-items:center;';
    priceBanner.innerHTML = '<span class="hl-pb-sale" style="font-weight:700;font-size:20px;line-height:27px;color:#009370;">$59.99</span><span class="hl-pb-orig" style="font-weight:400;font-size:20px;line-height:27px;color:#08122a;text-decoration:line-through;">$147</span><span class="hl-pb-badge" style="font-weight:700;font-size:15px;line-height:100%;background:#009370;color:#fff;border-radius:5.65px;height:27px;display:inline-flex;align-items:center;justify-content:center;padding:0 12px;">JULY 4TH SALE - Save $87</span>';
    cards[0].parentElement.insertBefore(priceBanner, cards[0]);

    var cartUrls = [
      'https://herluteal.com/cart/47792508428549:1',
      'https://herluteal.com/cart/47792508461317:1',
      'https://herluteal.com/cart/47792508494085:1'
    ];
    // Gift order: 0=Free Shipping, 1=PMDD vs Real You, 2=Survival Guide, 3=Calm Plate
    var giftUnlockMap = {
      0: [0],
      1: [0, 1, 2],
      2: [0, 1, 2, 3]
    };
    var giftLabels = ['Free Shipping', 'FREE Ebook', 'FREE Ebook', 'FREE Ebook'];
    var tierCallouts = {
      0: '<div style="padding:10px 14px;background:#f0faf5;border-radius:6px;margin-top:8px;border-left:3px solid #1a5c3a;"><div style="display:flex;align-items:center;gap:8px;"><svg width="18" height="18" fill="#1a5c3a" viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg><span style="font-size:13px;color:#1a1a1a;"><strong>FREE Shipping ($6.99 Value)</strong></span></div><div style="font-size:11px;color:#666;margin-top:2px;padding-left:26px;">Fast tracked delivery to your door</div></div>',
      1: '<div style="padding:12px 14px;background:#f0faf5;border-radius:6px;margin-top:8px;border-left:3px solid #1a5c3a;"><div style="display:flex;align-items:center;gap:8px;"><svg width="18" height="18" fill="#1a5c3a" viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg><span style="font-size:13px;color:#1a1a1a;"><strong>FREE 1 Extra Bottle ($49 Value)</strong></span></div><div style="font-size:11px;color:#666;margin-top:2px;padding-left:26px;">Full 90-day supply — 3 bottles total</div><div style="text-align:center;margin:8px 0 6px;font-size:10px;font-weight:700;color:#1a5c3a;letter-spacing:0.5px;text-transform:uppercase;">PLUS FREE GIFTS</div><div style="display:flex;align-items:center;gap:8px;margin-bottom:6px;"><svg width="16" height="16" fill="#1a5c3a" viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg><span style="font-size:12px;color:#1a1a1a;"><strong>FREE PMDD vs The Real You Workbook ($19 Value)</strong></span></div><div style="font-size:11px;color:#666;margin-top:-4px;padding-left:24px;margin-bottom:8px;">Separate your identity from your symptoms</div><div style="display:flex;align-items:center;gap:8px;margin-bottom:6px;"><svg width="16" height="16" fill="#1a5c3a" viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg><span style="font-size:12px;color:#1a1a1a;"><strong>FREE The Luteal Phase Survival Guide ($19 Value)</strong></span></div><div style="font-size:11px;color:#666;margin-top:-4px;padding-left:24px;margin-bottom:8px;">7-day protocol for surviving your luteal phase</div><div style="display:flex;align-items:center;gap:8px;"><svg width="16" height="16" fill="#1a5c3a" viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg><span style="font-size:12px;color:#1a1a1a;"><strong>FREE Shipping ($6.99 Value)</strong></span></div></div>',
      2: '<div style="padding:12px 14px;background:#f0faf5;border-radius:6px;margin-top:8px;border-left:3px solid #1a5c3a;"><div style="display:flex;align-items:center;gap:8px;"><svg width="18" height="18" fill="#1a5c3a" viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg><span style="font-size:13px;color:#1a1a1a;"><strong>FREE 2 Extra Bottles ($98 Value)</strong></span></div><div style="font-size:11px;color:#666;margin-top:2px;padding-left:26px;">Full 150-day supply — 5 bottles total</div><div style="text-align:center;margin:8px 0 6px;font-size:10px;font-weight:700;color:#1a5c3a;letter-spacing:0.5px;text-transform:uppercase;">PLUS FREE GIFTS</div><div style="display:flex;align-items:center;gap:8px;margin-bottom:6px;"><svg width="16" height="16" fill="#1a5c3a" viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg><span style="font-size:12px;color:#1a1a1a;"><strong>FREE PMDD vs The Real You Workbook ($19 Value)</strong></span></div><div style="font-size:11px;color:#666;margin-top:-4px;padding-left:24px;margin-bottom:8px;">Separate your identity from your symptoms</div><div style="display:flex;align-items:center;gap:8px;margin-bottom:6px;"><svg width="16" height="16" fill="#1a5c3a" viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg><span style="font-size:12px;color:#1a1a1a;"><strong>FREE The Luteal Phase Survival Guide ($19 Value)</strong></span></div><div style="font-size:11px;color:#666;margin-top:-4px;padding-left:24px;margin-bottom:8px;">7-day protocol for surviving your luteal phase</div><div style="display:flex;align-items:center;gap:8px;margin-bottom:6px;"><svg width="16" height="16" fill="#1a5c3a" viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg><span style="font-size:12px;color:#1a1a1a;"><strong>FREE The PMDD Calm Plate ($19 Value)</strong></span></div><div style="font-size:11px;color:#666;margin-top:-4px;padding-left:24px;margin-bottom:8px;">7-day anti-inflammatory meal plan for your cycle</div><div style="display:flex;align-items:center;gap:8px;"><svg width="16" height="16" fill="#1a5c3a" viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg><span style="font-size:12px;color:#1a1a1a;"><strong>FREE Shipping ($6.99 Value)</strong></span></div></div>'
    };
    function selectTier(tierIdx) {

      // Update price banner
      var pb = block.querySelector('.hl-price-banner');
      if(pb && tierPrices[tierIdx]){
        pb.querySelector('.hl-pb-sale').textContent = tierPrices[tierIdx].sale;
        pb.querySelector('.hl-pb-orig').textContent = tierPrices[tierIdx].orig;
        pb.querySelector('.hl-pb-badge').textContent = 'JULY 4TH SALE - Save ' + tierPrices[tierIdx].save;
      }

      cards.forEach(function(card, i) {
        var callout = card.querySelector('.hl-tier-gift-callout');
        if (i === tierIdx) {
          card.style.border = '2.5px solid #1a5c3a';
          card.style.boxShadow = '0 2px 8px rgba(26,92,58,0.08)';
          if (callout) { callout.style.display = 'block'; callout.innerHTML = tierCallouts[i] || ''; }
        } else {
          card.style.border = '1.5px solid #e5e5e5';
          card.style.boxShadow = 'none';
          if (callout) { callout.style.display = 'none'; }
        }
      });
      // Update gifts
      var unlocked = giftUnlockMap[tierIdx] || [];
      gifts.forEach(function(gift, i) {
        var isUnlocked = unlocked.indexOf(i) !== -1;
        var iconDiv = gift.querySelector('.hl-gift-icon');
        var labelDiv = gift.querySelector('.hl-gift-label');
        var badgeDiv = gift.querySelector('.hl-gift-badge');
        if (isUnlocked) {
          gift.style.opacity = '1';
          if (iconDiv) {
            iconDiv.style.background = '#f0faf5';
            iconDiv.style.borderColor = '#e0efe6';
          }
          if (badgeDiv) badgeDiv.style.display = 'block';
          if (labelDiv) {
            labelDiv.style.color = '#1a5c3a';
            labelDiv.style.fontWeight = '700';
            labelDiv.textContent = giftLabels[i];
          }
        } else {
          gift.style.opacity = '0.4';
          if (iconDiv) {
            iconDiv.style.background = '#f5f5f5';
            iconDiv.style.borderColor = '#eee';
          }
          if (badgeDiv) badgeDiv.style.display = 'none';
          if (labelDiv) {
            labelDiv.style.color = '#999';
            labelDiv.style.fontWeight = '600';
            labelDiv.textContent = 'Locked';
          }
        }
      });
      // Update CTA
      if (ctaBtn) ctaBtn.onclick = function(){ window.location.href = cartUrls[tierIdx]; };
    }
    cards.forEach(function(card, i) {
      card.addEventListener('click', function() { selectTier(i); });
    });
    selectTier(1); // Default to tier 1 (Most Popular - Buy 2 Get 1 Free)
  }
  document.querySelectorAll('.hl-offer-block').forEach(setupOfferBlock);
  // Delivery date
  var delivDate = new Date(); delivDate.setDate(delivDate.getDate() + 4);
  var days = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
  var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var dateStr = days[delivDate.getDay()] + ', ' + months[delivDate.getMonth()] + ' ' + delivDate.getDate();
  document.querySelectorAll('#hl-delivery-date').forEach(function(el){ el.textContent = dateStr; });
})();
/* cache-bust: 1783279013 */
/* v2 */

/* === MOBILE SECTIONS INJECTION === */
;(function(){
"use strict";
if(window.innerWidth>768)return;
function injectMobileSections(){
var d=document.querySelector('.hl-hero-desktop');
var m=document.querySelector('.hl-hero-mobile');
if(!d||!m)return;
var c=document.createElement('div');
c.className='hl-mobile-injected';
c.style.cssText='padding:0 16px;margin-top:16px;';
var divs=d.getElementsByTagName('div');
var i,s,bg;
for(i=0;i<divs.length;i++){
s=divs[i].style;
if(s.background&&s.background.indexOf('F0FBF4')>-1&&divs[i].textContent.indexOf('23,847')>-1){
c.appendChild(divs[i].cloneNode(true));break;}}
for(i=0;i<divs.length;i++){
bg=divs[i].style.background||divs[i].style.backgroundColor||'';
if(bg.indexOf('1A3C2A')>-1||bg.indexOf('1a3c2a')>-1){
c.appendChild(divs[i].cloneNode(true));break;}}
for(i=0;i<divs.length;i++){
s=divs[i].style;
if(s.display==='grid'&&s.gridTemplateColumns&&s.gridTemplateColumns.indexOf('repeat(4')>-1&&divs[i].textContent.indexOf('Clinical')>-1){
var tb=divs[i].cloneNode(true);
tb.style.gridTemplateColumns='repeat(2,1fr)';
tb.style.gap='8px';
c.appendChild(tb);break;}}
var btns=d.querySelectorAll('[data-accordion-btn]');
if(btns.length>0){
var el=btns[0].parentElement;
while(el&&el!==d){
if(el.querySelectorAll('[data-accordion-btn]').length>=4){
c.appendChild(el.cloneNode(true));break;}
el=el.parentElement;}}
if(c.children.length>0){
m.parentNode.insertBefore(c,m.nextSibling);
c.querySelectorAll('[data-accordion-btn]').forEach(function(b){
b.addEventListener('click',function(){
var p=this.nextElementSibling;
var ic=this.querySelector('span:last-child');
if(p){var o=p.style.display!=='none';p.style.display=o?'none':'block';
if(ic)ic.textContent=o?'+':'\u2212';}});});}}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',injectMobileSections);}
else{injectMobileSections();}
})();

// === OFFER IMAGE SWAP ON TIER SELECTION ===
(function() {
  var offerSrcs = [
    'https://cdn.shopify.com/s/files/1/0870/0788/7637/t/1/assets/hl-1-bottle-nobg.png',
    'https://cdn.shopify.com/s/files/1/0870/0788/7637/t/1/assets/hl-offer-buy2get1.png',
    'https://cdn.shopify.com/s/files/1/0870/0788/7637/t/1/assets/hl-offer-buy3get2.png'
  ];

  function insertOfferImage() {
    // Find ALL hl-offer-block containers (there may be multiple for desktop/mobile)
    var blocks = document.querySelectorAll('.hl-offer-block');
    blocks.forEach(function(block) {
      // Skip if already has an offer image inserted
      if (block.querySelector('.hl-offer-img-container')) return;
      
      // Find the CTA button inside this block
      var cta = block.querySelector('[data-cta]');
      if (!cta) return;
      
      // Create the offer image container
      var container = document.createElement('div');
      container.className = 'hl-offer-img-container';
      container.style.cssText = 'text-align:center;margin:20px auto 15px;padding:0 10px;max-width:450px';
      
      // Determine which tier is currently selected
      var selectedTier = block.querySelector('[data-tier][style*="border-color"]');
      var tierIdx = 1; // default to Buy 2 Get 1 Free
      if (selectedTier) {
        tierIdx = parseInt(selectedTier.getAttribute('data-tier')) || 1;
      }
      
      var img = document.createElement('img');
      img.className = 'hl-offer-swap-img';
      img.src = offerSrcs[tierIdx];
      img.alt = 'HerLuteal Offer';
      img.style.cssText = tierIdx === 0 
        ? 'width:200px;max-width:200px;filter:drop-shadow(rgba(0,0,0,0.4) 0px 14px 36px);transition:opacity 0.3s ease'
        : 'width:100%;max-width:420px;border-radius:12px;transition:opacity 0.3s ease';
      
      container.appendChild(img);
      
      // Insert BEFORE the CTA button
      var lastTier = block.querySelectorAll('.hl-tier-card');
    if (lastTier.length > 0) {
      var insertAfterEl = lastTier[lastTier.length - 1];
      if (insertAfterEl.nextSibling) {
        block.insertBefore(container, insertAfterEl.nextSibling);
      } else {
        block.appendChild(container);
      }
    } else {
      block.insertBefore(container, cta);
    };
    });
  }

  function swapOfferImage(tier) {
    // Swap the CAROUSEL main image to show the offer for the selected tier
    var prevBtn = document.querySelector("[data-carousel-prev]");
    var carouselImg = null;
    if (prevBtn) {
      carouselImg = prevBtn.parentElement.querySelector("img");
    }
    // Also find any standalone offer images (below tier cards)
    var offerImgs = document.querySelectorAll('.hl-offer-swap-img');
    
    // Swap carousel main image
    if (carouselImg) {
      carouselImg.style.opacity = '0';
      setTimeout(function() {
        carouselImg.src = offerSrcs[tier];
        carouselImg.alt = tier === 0 ? '1 Bottle' : tier === 1 ? 'Buy 2 Get 1 Free' : 'Buy 3 Get 2 Free';
        carouselImg.style.opacity = '1';
      }, 180);
    }
    
    // Also swap any standalone offer images
    offerImgs.forEach(function(img) {
      img.style.opacity = '0';
      setTimeout(function() {
        img.src = offerSrcs[tier];
        if (tier === 0) {
          img.style.width = '200px';
          img.style.maxWidth = '200px';
          img.style.borderRadius = '0';
          img.style.filter = 'drop-shadow(rgba(0,0,0,0.4) 0px 14px 36px)';
        } else {
          img.style.width = '100%';
          img.style.maxWidth = '420px';
          img.style.borderRadius = '12px';
          img.style.filter = 'none';
        }
        img.style.opacity = '1';
      }, 150);
    });
  }
  // Use event delegation for tier clicks
  document.addEventListener('click', function(e) {
    var card = e.target.closest('[data-tier]');
    if (card) {
      var tier = parseInt(card.getAttribute('data-tier'));
      setTimeout(function() { swapOfferImage(tier); }, 50);
    }
  });

  // Insert offer images after DOM is ready and after hl-patch.js has done its DOM manipulation
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(insertOfferImage, 500);
    });
  } else {
    setTimeout(insertOfferImage, 500);
  }
  
  // Also re-run after 2s in case hl-patch.js injects new sections later
  setTimeout(insertOfferImage, 2000);
  setTimeout(insertOfferImage, 4000);
})();

/* === TIER CAROUSEL SWAP START === */
;(function(){
  var offerSrcs = {
    0: 'https://cdn.shopify.com/s/files/1/0870/0788/7637/t/1/assets/hl-pdp-slide-benefits-new.png',
    1: 'https://cdn.shopify.com/s/files/1/0870/0788/7637/t/1/assets/hl-offer-buy2get1.png',
    2: 'https://cdn.shopify.com/s/files/1/0870/0788/7637/t/1/assets/hl-offer-buy3get2.png'
  };
  function swapCarousel(tier) {
    var src = offerSrcs[tier];
    if (!src) return;
    var prevBtn = document.querySelector('[data-carousel-prev]');
    var container = prevBtn ? prevBtn.parentElement : null;
    var img = container ? container.querySelector('img') : null;
    if (img) {
      img.style.transition = 'opacity 0.2s';
      img.style.opacity = '0';
      setTimeout(function() { img.src = src; img.style.opacity = '1'; }, 200);
    }
  }
  function setupObserver() {
    var cards = document.querySelectorAll('[data-tier]');
    if (!cards.length) { setTimeout(setupObserver, 500); return; }
    var observer = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'attributes') {
          var card = m.target.closest ? m.target.closest('[data-tier]') : null;
          if (!card) continue;
          var style = card.getAttribute('style') || '';
          if (style.indexOf('border') > -1 && (style.indexOf('rgb') > -1 || style.indexOf('#') > -1)) {
            var tier = parseInt(card.getAttribute('data-tier'));
            if (!isNaN(tier)) swapCarousel(tier);
            break;
          }
        }
      }
    });
    cards.forEach(function(card) {
      observer.observe(card, { attributes: true, attributeFilter: ['style', 'class'], subtree: false });
    });
    // Also observe for new tier cards being added (hl-patch.js clones sections)
    var bodyObserver = new MutationObserver(function() {
      var newCards = document.querySelectorAll('[data-tier]:not([data-observed])');
      newCards.forEach(function(card) {
        card.setAttribute('data-observed', '1');
        observer.observe(card, { attributes: true, attributeFilter: ['style', 'class'], subtree: false });
      });
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
    // Mark existing cards
    cards.forEach(function(c) { c.setAttribute('data-observed', '1'); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(setupObserver, 100); });
  } else {
    setTimeout(setupObserver, 100);
  }
})();
/* === TIER CAROUSEL SWAP END === */
